import { useEffect, useState } from "react";
import { permissionAction } from "../../utils/userInfo";

const allPermissionList = permissionAction();

const formatAction = (formatList) => {
  return formatList.reduce((a, v) => {
    const action = v.split("__")[2];
    return { ...a, [action]: v };
  }, {});
};

export const useAccountPermission = () => {
  const [userPermission, setUserPermission] = useState();

  useEffect(() => {
    const formatList = allPermissionList.filter((permission) =>
      permission.includes("USER__ACCOUNT")
    );
    const actions = formatAction(formatList);
    setUserPermission(actions);
  }, []);

  return userPermission;
};

export const useRbacPermission = () => {
  const [userPermission, setUserPermission] = useState();

  useEffect(() => {
    const formatList = allPermissionList.filter((permission) =>
      permission.includes("USER__RBAC")
    );
    const actions = formatAction(formatList);
    setUserPermission(actions);
  }, []);

  return userPermission;
};
